import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import { css } from "styled-components";
import { createStyleComponent, getThemeData } from "@hzero-front-ui/core";
var getDropdownCss = function getDropdownCss(props) {
  var _getThemeData = getThemeData(props, "button"),
    radius = _getThemeData.radius;
  return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    .c7n-btn-group.c7n-pro-dropdown-button {\n      box-shadow: none;\n      .c7n-pro-btn:nth-child(1) {\n        border-radius: ", "px 0 0 ", "px;\n      }\n      .c7n-pro-btn:nth-child(2) {\n        border-radius: 0 ", "px ", "px 0;\n        margin: 0 0 0 -0.01rem;\n      }\n    }\n  "])), radius, radius, radius, radius);
};
export default createStyleComponent("dropdown", getDropdownCss);